var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"garage-list"},_vm._l((_vm.list),function(item){return _c('div',{key:`auto-${item.id}`,staticClass:"garage-list__item"},[_vm._t("default",null,{"item":item})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }